import React, { Component, Fragment } from "react"
import { NewDashboardServices, } from "../../services"
import "./newDashboard.css";

//components
import PageHeader from "../../components/Page/PageHeader/PageHeader"

export default class NewDashboard extends React.Component {
  state = {
    type: "",
    dashValues: [],
    newValues: ["Active Customers", "active departments", "active Employees", "total Fabrics", "total BNumbers", "total Sample Requests", "incomplete SignOff"]
  }

  componentDidMount() {
    // NewDashboardServices.activeCountNewDashboard()
    //   .then(response => {
    //     if (response.status == 200) {
    //       this.setState({ activeCount: response.text.activeCustomers });
    //     }
    //     response.status === 401 && this.props.unauthorisedFunc();
    //   })
    //   .catch(error => {
    //     this.props.getalertMessage("error", error);
    //   });

    Promise.allSettled([NewDashboardServices.activeCountNewDashboard(), NewDashboardServices.activeDepartmentsNewDashboard(), NewDashboardServices.activeEmployeesNewDashboard(), NewDashboardServices.fabricCountNewDashboard(), NewDashboardServices.bNumberCountNewDashboard(), NewDashboardServices.sampleRequestCountNewDashboard(), NewDashboardServices.completedSampleRequestCountNewDashboard()])
      .then((results) => {
        const allDatas = [];
        results.forEach((res) => {
          if (res.status === "fulfilled") {
            allDatas.push(res.value.text)
          }
        });
        this.setState({ dashValues: allDatas });
      })
      .catch(error => this.props.getalertMessage('error', error.toString()));
  }


  render() {

    const { newValues, dashValues } = this.state || [];
    return (
      <Fragment>
        <div class="right-section">
          <div class="row nopadding">
            <div class="col-md-12 nopadding">
              <div
                class="card-filter meeting-min-con"
                style={{ marginBottom: "0.5%" }}
              >
                <div class="row fabric-list-con">
                  <PageHeader
                    header={"NEW DASHBOARD"}
                    history={this.props.history}
                  />
                </div>
              </div>
              <div
                class="card-filter meeting-min-con"
                style={{ marginBottom: "0.5%" }}
              >
                <div class="row fabric-list-con">
                  <div
                    class="col-md-12 product-form"
                    style={{ paddingBottom: "1%" }}
                  >
                    <h6 class="dev-title" style={{ paddingBottom: "10px" }}>
                      <b>New Dashboard</b>
                    </h6>
                    {
                      dashValues && dashValues.map((dash, index) => {
                        return (
                          <div className="col-md-3">
                            <div className="box-con">
                              <div className="cart-list">
                                <p>
                                  {
                                    newValues[index]
                                  }
                                </p>
                                <span>{dash.count || 0}</span>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/newDashboard/page.js